import { render, staticRenderFns } from "./sumarios-publicados.vue?vue&type=template&id=e1035e1e&"
import script from "./sumarios-publicados.vue?vue&type=script&lang=js&"
export * from "./sumarios-publicados.vue?vue&type=script&lang=js&"
import style0 from "./sumarios-publicados.vue?vue&type=style&index=0&id=e1035e1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports